export default __webpack_public_path__ + "static/media/searchBlack.2f32df9f.svg";